var _path, _ellipse, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoublecabinpickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,12.5v2.2H1v-3.3h7.2V7.3h9.5l2.1,3.7l2.5,0.5c0.1,0,0.2,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.3 C22.9,12,23,12.2,23,12.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "18.6,10.6 17.1,7.7 14.6,7.7 14.6,10.6 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11.3,
    style: {
      fill: "#000"
    },
    width: 1.1,
    height: 0.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.4,14.7h-4c0.2-0.9,1-1.6,2-1.6C18.4,13,19.2,13.7,19.4,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M7.7,14.7h-4c0.1-0.4,0.3-0.7,0.5-1C4.7,13.3,5.2,13,5.7,13c0,0,0.1,0,0.1,0C6.8,13.1,7.5,13.8,7.7,14.7z"
  })), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4,
    cy: 15.1,
    rx: 1.7,
    ry: 1.7
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 17.4,
    cy: 15.1,
    r: 1
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4,
    cy: 15.1,
    r: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8,13.4c-1,0-1.8,0.7-1.8,1.8c0,0.8,0.7,1.5,1.5,1.5c1,0,1.8-0.7,1.8-1.8C7.3,14.1,6.6,13.5,5.8,13.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.8,14.1c-0.6,0-1.1,0.5-1.1,1.1c0,0.5,0.4,0.8,0.9,0.9c0.6,0,1.1-0.5,1.1-1.1C6.6,14.5,6.3,14.1,5.8,14.1z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8,14.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.3,0.3,0.5,0.5,0.5c0.4,0,0.7-0.3,0.7-0.7C6.3,14.7,6.1,14.5,5.8,14.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M23,12.5v0.9h-0.4c-0.4,0-0.7-0.3-0.7-0.7V12c0-0.1,0.1-0.2,0.2-0.2h0.7C22.9,12,23,12.2,23,12.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "13.1,10.6 13.1,7.7 9.1,7.7 9.1,10.6 "
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublecabinpickup);
export default __webpack_public_path__ + "static/media/doublecabinpickup.c22ccabcc0fe2e0c8c46480ab4249a0c.svg";
export { ForwardRef as ReactComponent };